module.exports = __webpack_public_path__ + "img/icon_device2.40eb2921.png";